export default __webpack_public_path__ + "static/media/graduate.47b7be34.png";